module.exports = __webpack_public_path__ + "static/media/backIcon.3eeb86f9.svg";